enum ClockType {
  HOURS = 'hours',

  MINUTES = 'minutes',

  SECONDS = 'seconds',
}

export type ClockViewType = 'hours' | 'minutes' | 'seconds';

export default ClockType;



// WEBPACK FOOTER //
// ../../src/constants/ClockType.ts